import { render, staticRenderFns } from "./PptSlideViewer.vue?vue&type=template&id=efa49200&scoped=true&"
import script from "./PptSlideViewer.vue?vue&type=script&lang=js&"
export * from "./PptSlideViewer.vue?vue&type=script&lang=js&"
import style0 from "./PptSlideViewer.vue?vue&type=style&index=0&id=efa49200&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa49200",
  null
  
)

export default component.exports